import { render, staticRenderFns } from "./MediaUp.vue?vue&type=template&id=6bce93fe&scoped=true"
import script from "./MediaUp.vue?vue&type=script&lang=js"
export * from "./MediaUp.vue?vue&type=script&lang=js"
import style0 from "./MediaUp.vue?vue&type=style&index=0&id=6bce93fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce93fe",
  null
  
)

export default component.exports